var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6666 10.32V10.3733C34.6666 12.16 35.8666 13.6533 37.5466 14.1867C45.1466 16.56 50.6666 23.6267 50.6666 32C50.6666 33.3867 50.5066 34.6933 50.2133 35.9733C49.84 37.68 50.5333 39.44 52.0533 40.3467L52.08 40.3733C54.3733 41.7067 57.36 40.5067 57.9733 37.9467C58.4266 36.0267 58.6666 34.0267 58.6666 32C58.6666 20 50.72 9.81332 39.7866 6.47999C37.2533 5.70666 34.6666 7.65332 34.6666 10.32ZM29.1733 50.4533C21.2 49.3067 14.72 42.8267 13.5466 34.88C12.1066 25.28 17.9733 16.8267 26.4266 14.1867C28.1333 13.68 29.3333 12.16 29.3333 10.3733V10.32C29.3333 7.65332 26.7466 5.70666 24.1866 6.47999C12.16 10.16 3.75997 22.1067 5.57331 35.7067C7.14664 47.3867 16.5866 56.8267 28.2666 58.4C36.64 59.52 44.3733 56.7733 49.9466 51.6533C51.92 49.84 51.5733 46.6133 49.2533 45.28C47.7066 44.3733 45.7866 44.6667 44.4533 45.8667C40.5333 49.44 35.0933 51.3333 29.1733 50.4533Z",
    fill: "#288344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionIcon);
export default __webpack_public_path__ + "static/media/VisionIcon.343980aad513adf8dfc462d76a7b6eeb.svg";
export { ForwardRef as ReactComponent };